import { configureStore } from "@reduxjs/toolkit";
import productReducer from "./slices/productReducer";
import portfolioReducer from "./slices/portfolioReducer";
import blogReducer from "./slices/blogReducer";
import officeReducer from "./slices/officeReducer";
import contactReducer from "./slices/contactReducer";
const store = configureStore({
  reducer: {
    products:productReducer,
    portfolio:portfolioReducer,
    blogs:blogReducer,
    office:officeReducer,
    contact:contactReducer
  },
});

export default store;
